// The backend stores a Rutter failure as a Ruby hash dump, e.g.
// `450: {"error_code" => "...", "error_metadata" => {"human_readable" => "..."}}`
const quotedHashValue = String.raw`\s*(?:=>|:)\s*"((?:[^"\\]|\\.)*)"`;
const humanReadablePattern = new RegExp(`"human_readable"${quotedHashValue}`);
const errorMessagePattern = new RegExp(`"error_message"${quotedHashValue}`);

export const getRutterExportErrorMessage = (lastError: string) => {
  const match =
    humanReadablePattern.exec(lastError) ?? errorMessagePattern.exec(lastError);
  const message = match?.[1];

  return message ? message.replace(/\\(["\\])/g, '$1') : lastError;
};
